import React from 'react'
import { connect } from 'react-redux'

import BulmaModalLayout from './components/BulmaModalLayout'
import { hideModal } from './redux/modalAction'

const MODAL_COMPONENTS = {}

class ModalProvider extends React.Component {
  render() {
    if (!this.props.modalType) {
      return null
    }

    const ModalLayout = this.props.modalLayout || BulmaModalLayout
    const modalComponents = {
      ...MODAL_COMPONENTS,
      ...this.props.modalComponents,
    }

    const SpecificModal = modalComponents[this.props.modalType]
    return (
      <ModalLayout
        isActive={this.props.isActive}
        modalActions={{ hideModal: this.props.hideModal }}
      >
        <SpecificModal />
      </ModalLayout>
    )
  }
}

export default connect(
  ({ modal }) => ({
    modalType: modal.modalType,
    isActive: modal.isActive,
  }),
  { hideModal: hideModal },
)(ModalProvider)



// WEBPACK FOOTER //
// ./src/modules/redux-modal/ModalProvider.js